import { request } from "./client";
import type { components } from "./schema";

type Schemas = components["schemas"];
export type Reviewer = Schemas["ReviewerOut"];
export type QueueRow = Schemas["QueueRow"];
export type CandidateReview = Schemas["CandidateReview"];
export type AnswerCard = Schemas["AnswerCard"];
export type Flag = Schemas["Flag"];
export type QuestionMetrics = Schemas["QuestionMetrics"];
export type AgentFluency = Schemas["AgentFluency"];
export type Decision = Schemas["DecisionIn"]["decision"];
export type LlmSpend = Schemas["LlmSpend"];
export type Summary = Schemas["SummaryOut"];
export type Funnel = Schemas["FunnelOut"];
export type CandidateStep = Schemas["CandidateStep"];
export type QueueView = "awaiting" | "decided" | "all";

const enc = encodeURIComponent;

export const reviewApi = {
  me: () => request<Reviewer>("/api/review/me"),
  queue: (view: QueueView, step: string) =>
    request<QueueRow[]>(`/api/review/queue?view=${view}&step=${enc(step)}`),
  funnel: () => request<Funnel>("/api/review/funnel"),
  llmSpend: () => request<LlmSpend>("/api/review/llm-spend"),
  candidate: (publicId: string) =>
    request<CandidateReview>(`/api/review/applications/${enc(publicId)}`),
  generateSummary: (publicId: string) =>
    request<CandidateReview>(`/api/review/applications/${enc(publicId)}/summary`, {
      method: "POST",
    }),
  decide: (publicId: string, decision: Decision, reasoning: string) =>
    request<CandidateReview>(`/api/review/applications/${enc(publicId)}/decision`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ decision, reasoning }),
    }),
};
